import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UserCarsViewModal = ({ isOpen, onClose, item, language, onEdit, onDelete }) => {
  if (!isOpen || !item) return null;

  const labels = {
    title: { en: 'Car Profile Details', ar: 'تفاصيل ملف السيارة' },
    user: { en: 'User', ar: 'المستخدم' },
    carType: { en: 'Car Type', ar: 'نوع السيارة' },
    model: { en: 'Model', ar: 'الطراز' },
    year: { en: 'Year', ar: 'السنة' },
    licensePlate: { en: 'License Plate', ar: 'لوحة الترخيص' },
    preferences: { en: 'Preferences', ar: 'التفضيلات' },
    edit: { en: 'Edit', ar: 'تعديل' },
    delete: { en: 'Delete', ar: 'حذف' },
    close: { en: 'Close', ar: 'إغلاق' }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="border-b border-border px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">
            {labels?.title?.[language]}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.user?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">{item?.user}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.carType?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">{item?.carType}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.model?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">{item?.model}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.year?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">{item?.year}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.licensePlate?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">
              <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-primary/10 text-primary text-sm font-medium">
                {item?.licensePlate}
              </span>
            </p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.preferences?.[language]}</label>
            <div className="flex flex-wrap gap-2 mt-2">
              {item?.preferences?.map((pref, i) => (
                <span key={i} className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-primary/10 text-primary">
                  {pref}
                </span>
              ))}
            </div>
          </div>

          <div className="flex gap-3 pt-4">
           {/* <Button
              variant="outline"
              fullWidth
              onClick={onEdit}
              iconName="Edit2"
            >
              {labels?.edit?.[language]}
            </Button>*/}
            <Button
              variant="destructive"
              fullWidth
              onClick={onDelete}
              iconName="Trash2"
            >
              {labels?.delete?.[language]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCarsViewModal;